
import { Component, mixins, namespace } from 'nuxt-property-decorator';
import { PageType, PageScope, PageDto } from 'fourwaves-shared';
import {
  DateCarousel,
  SessionCard,
  NoResults,
  SessionFilterBar,
  CalendarDateIcon,
  SessionIndexMixin,
} from 'fourwaves-shared/components';
import { NuxtError } from '@nuxt/types';

const EventsModule = namespace('events');

@Component({
  components: {
    DateCarousel,
    SessionCard,
    NoResults,
    SessionFilterBar,
    CalendarDateIcon,
  },
  scrollToTop: true,
  validate({ store }) {
    const page = store.state.events.pages.find(({ type }: PageDto) => type === PageType.Schedule);
    if (page && page.scope === PageScope.Participants) {
      if (!store.$auth.loggedIn) {
        const error: NuxtError = Error();
        error.statusCode = 401;
        throw error;
      } else if (!store.getters['events/isParticipant'] && !store.getters['events/isOrganizer']) {
        const error: NuxtError = Error();
        error.statusCode = 403;
        throw error;
      }
    }
    return !!page;
  },
})
export default class SchedulePage extends mixins(SessionIndexMixin) {
  @EventsModule.State pages!: PageDto[];
  @EventsModule.Getter isLiveAppOpen!: boolean;

  public head() {
    return {
      title: this.pages.find(({ type }) => type === PageType.Schedule)
        ? this.transl8(this.pages.find(({ type }) => type === PageType.Schedule)!.name)
        : '',
    };
  }
}
